import React from 'react';
import {Helmet} from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Im1 from '../../images/acfabric/im1.jpg';
import Im2 from '../../images/acfabric/im2.jpg';
import Im3 from '../../images/acfabric/im3.jpg';
import Im4 from '../../images/acfabric/im4.jpg';
import Im5 from '../../images/acfabric/im5.jpg';
import Im6 from '../../images/acfabric/im6.jpg';
import Im7 from '../../images/acfabric/im7.jpg';
import Im8 from '../../images/acfabric/im8.jpg';
import Im9 from '../../images/acfabric/im9.jpg';
import Im10 from '../../images/acfabric/im10.jpg';
import './acfabric-intermix.css';
import ScrollToTopButton from '../ScrollButton';
function acfabricinter() {
    return (
      
    <>
    <Helmet>
    <title>Acoustic of Maine Intermix Fabric - Acoustical Surfaces</title>
    <meta name="description" content="" />
    <meta property="og:title" content="AcoustyFABRIC Intermix" />
    <meta property="og:description" content="Guilford of Maine Intermix 3035 Fabric Facings" />
    <meta property="og:image" content="https://www.acousticalsurfaces.in/images/acfabric/im1.jpg" />
    <meta property="og:locale" content="en-in" />
    <meta name="geo.placename" content="India" />
    <meta http-equiv="content-language" content="in" />
    <meta name="geo.region" content="india" />
    <link rel="canonical" href="https://www.acousticalsurfaces.in/acfabric-intermix" />
    <link rel="alternate" href="https://www.acousticalsurfaces.in/acfabric-intermix" hreflang="en-in" />
    <link rel="alternate" href="https://www.acousticalsurfaces.ae/acfabric-intermix" hreflang="en-ae" />
    </Helmet>
    <Header />
    <section className="content" id="acfabricintermix">
        <div className="container">
            <div className="row">
                <div className="col-sm-3 sidemenu">
                    <Sidebar />
                </div>
            	<div className="col-sm-9 product-page nopaddding">
                    <div className="container"> 
                        <div className="megamenu">
                            <Megamenu />
				        </div>
                    </div>
	                <div className="col-sm-12 heading-fsorb">				
		                <h1>Acousty<span className="fabriwall">FABRIC</span> Intermix</h1>
                        <h4 className="mb-0"> <b>Guilford of Maine Intermix 3035 Fabric Facings</b></h4>
		                <p><span className="color:red;">(Colors Shown are Approximate Match to Material)</span></p>
	                    <br />
		                <div className="col-sm-3 cloths p-0"><button>Product Specifications</button></div>
	                </div>
		            <br /><br />
		            <div className="col-sm-12 cloths">
		                <div className="row d-flex justify-content-center mb-2">
                        	<div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im1} alt="Butter Rum" />
                                <p className="text-center">Butter Rum 050</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im2} alt="Coconut" />
                                <p className="text-center">Coconut 011</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im3} alt="Foggy" />
                                <p className="text-center">Foggy 041</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im4} alt="Husky" />
                                <p className="text-center">Husky 060</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im5} alt="Marsh" />
                                <p className="text-center">Marsh 062</p>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center mb-2">
                        	<div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im6} alt="Neptune" />
                                <p className="text-center">Neptune 040</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im7} alt="Rocket Ship" />
                                <p className="text-center">Rocket Ship 010</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im8} alt="Seagull" />
                                <p className="text-center">Seagull 030</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im9} alt="Smoky Qartz" />
                                <p className="text-center">Smoky Quartz 061</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Im10} alt="Swan" />
                                <p className="text-center">Swan 020</p>
                            </div>
                        </div>	
                    </div>
		            <br />
		            <hr />
                    <div className="col-12 d-flex justify-content-center backbtn">
                    	<Link to="/acoustyfabric"><button>Back to Acousty<span style={{color: "red"}}>FABRIC</span></button></Link>
                    </div>
                    <hr />
                    <div className="col-sm-12 application">
			            <h1>APPLICATION</h1>
                    	<div className="hover14 text-center justify-content-center">
		                <br />
  		                    <div className="col-sm-12">
			                    <figure className="m-0"><div className="tinted-image">CINEMA HALL</div></figure>
 		                    </div>
                        <br />
  		                    <div className="col-sm-12">
    	                        <figure className="m-0"><div className="tinted-image2">OFFICE ROOMS & HALLS</div></figure>
 		                    </div>
                        <br />
  		                    <div className="col-sm-12">
    	                        <figure className="m-0"><div className="tinted-image3">AUDITORIUM & EDUCATION</div></figure>
 		                    </div>
                        <br />
		                </div>
                    </div>
		            <br />
                </div>
            </div>
            <div className='mobsidebar'>
                <div className="col-sm-12">
                    <div className="container">
                        <div className="row">
                            <Mobsidebar />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ScrollToTopButton />
    </section>
<Footer />
</>
);
}
export default acfabricinter;